const languages = ["fr", "en"]
const defaultLanguage = ["fr"]

const getTranslationUri = (translations, locale) => {
  const translation = translations?.length > 0 && translations[0]
  if (translation?.isFrontPage && locale === "en_GB") return "/"
  return translation?.isFrontPage ? "/en" : translation.uri
}

const getCurrentPageLanguage = pathname => {
  const pathElements = pathname.split("/")
  if (pathElements.includes("en")) return "en_GB"
  return "fr_FR"
}

export { languages, defaultLanguage, getTranslationUri, getCurrentPageLanguage }
